import React, { useRef, useState, useEffect } from "react";
import emailjs from "emailjs-com";
import Nav from "./Nav/Nav";
import { useLocation } from "react-router-dom";
import telefonIcon from "../utils/images/queryImages/telefon-icon.png";
import emailIcon from "../utils/images/queryImages/message-icon.png";
import bookingIcon from "../utils/images/queryImages/booking-icon.png";
import "./Query.css";

const ForFragan = ({ showPath, showTjanter }) => {
  const form = useRef();
  const [messageSent, setMessageSent] = useState(false);
  const [error, setError] = useState("");
  const [tjanst, setTjanst] = useState("");
  const [path, setPath] = useState("");
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tjanstValue = params.get("tjanst");
    const pathValue = params.get("path");
    if (tjanstValue) {
      setTjanst(tjanstValue);
    }
    if (pathValue) {
      setPath(pathValue);
    }
  }, [location]);

  const sendEmail = (e) => {
    e.preventDefault();
    setMessageSent(false);
    setError("");

    emailjs
      .sendForm(
        "service_zrzoy78", // replace with your EmailJS service ID
        "template_v5pxpfk", // replace with your EmailJS template ID
        form.current,
        "bTz8bG6R8DO3S-Aph" // Replace with your EmailJS public key
      )
      .then(
        (result) => {
          console.log(result.text);
          setMessageSent(true);
        },
        (error) => {
          console.log(error.text);
          setError("Failed to send message. Please try again.");
        }
      );
  };

  return (
    <div className="query-container">
      <Nav />
      <div className="query-hero"></div>
      <div className="query-content">
        <div className="query-contact-container">
          <div className="query-contact">
            <h2>Vi skapar digitala framgångar</h2>
            <p>Hör av dig och låt oss göra skillnad tillsammans!</p>

            <ul>
              <li>
                <img
                  src={bookingIcon}
                  alt="Booking-icon"
                  className="query-icon"
                ></img>
                Boka en kostnadsfri konsultation
              </li>
              <li>
                <img
                  src={telefonIcon}
                  alt="Telefon-icon"
                  className="query-icon"
                ></img>
                031-375 1055
              </li>
              <li>
                <img
                  src={emailIcon}
                  alt="Email-icon"
                  className="query-icon"
                ></img>
                info@centrum-foralla.se
              </li>
            </ul>
          </div>
        </div>
        <div className="query-form-wrapper">
          <h3>Boka en kostnadsfri konsultation</h3>

          {/* Conditional Rendering */}
          {messageSent ? (
            <p className="success-message">
              Tack för din förfrågan! Vi återkommer så snart som möjligt.
            </p>
          ) : error ? (
            <p className="error-message">{error}</p>
          ) : (
            <form className="query-form" ref={form} onSubmit={sendEmail}>
              <input
                type="text"
                name="namn"
                placeholder="Namn"
                onFocus={(e) => (e.target.placeholder = "")}
                onBlur={(e) => (e.target.placeholder = "Namn")}
                className="form-input"
                required
              />
              <input
                type="date"
                name="date"
                placeholder="Datum"
                className="form-input"
                onFocus={(e) => (e.target.placeholder = "")}
                onBlur={(e) => (e.target.placeholder = "Datum")}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="E-post"
                className="form-input"
                onFocus={(e) => (e.target.placeholder = "")}
                onBlur={(e) => (e.target.placeholder = "E-post")}
                required
              />
              <input
                type="tel"
                name="telefon"
                placeholder="Telefon"
                className="form-input"
                onFocus={(e) => (e.target.placeholder = "")}
                onBlur={(e) => (e.target.placeholder = "Telefon")}
                required
              />
              <select
                name="tjanster"
                className="form-select"
                required
                defaultValue=""
              >
                <option value="" disabled>
                  Välj tjänster
                </option>
                <option value="Webbdesign">Webbdesign</option>
                <option value="SEO">SEO</option>
                <option value="Digital Marknadsföring">
                  Digital Marknadsföring
                </option>
                <option value="Innehållsskapande">Innehållsskapande</option>
                <option value="PPC-annonsering">PPC-annonsering</option>
                <option value="E-handel">E-handel</option>
              </select>
              <textarea
                name="beskriv"
                rows="5"
                className="form-textarea"
                required
                placeholder="Meddelande"
                onFocus={(e) => (e.target.placeholder = "")}
                onBlur={(e) => (e.target.placeholder = "Meddelande")}
              ></textarea>

              {showPath && (
                <>
                  <label htmlFor="path">Path</label>
                  <input
                    type="text"
                    name="path"
                    value={path}
                    className="read-only-input"
                    readOnly
                  />
                </>
              )}

              {showTjanter && (
                <>
                  <label htmlFor="tjanster">Tjänster</label>
                  <input
                    type="text"
                    name="tjanster"
                    value={tjanst}
                    className="read-only-input"
                    readOnly
                  />
                </>
              )}

              <button type="submit" className="submit-button">
                Boka
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForFragan;
